import React, { Component, Fragment, useState } from 'react';
import { Image } from 'antd-mobile'
import { activityList } from '../../api/index';
import { dateFtt } from '../../utils/utils'

import moduleCss from "../list/index.module.scss";
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: []
    };
  }
  // 页面加载完成后，初始化地图，微信配置信息，用户位置
  async componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const type = params.get('type')
    document.title = type == 1 ? '景区公告' : '景区活动'
    this.setState({
      type
    })
    await this.getList(type);
  }
  getList(type) {
    activityList({
      message_type: type,
      page: 1,
      page_size: 10000
    }).then(res => {
      this.setState({
        list: res.data,
      });
    })
  }
  goDetail(link) {

    window.location.href = link
  }

  render() {
    const { list, type } = this.state;
    return (
      <div>
        <div className={moduleCss.banner}>
          <Image lazy className={moduleCss.img} src={require('../../assets/pic_banner2.png')} alt="" />
        </div>
        <div className={moduleCss.content}>
          <h1 className={moduleCss.title}>{type == 1 ? '公告' : '活动'}列表</h1>
          <div className={moduleCss.goodList}>
            {list.map((item, index) => (
              <div className={moduleCss.item} onClick={() => {
                this.goDetail(item.url)
              }}>
                <Image fit='cover' lazy className={moduleCss.img} src={item.banner} alt="" />
                <div className={`${moduleCss.right}`}>
                  <h1 className={moduleCss.name}>{item.title}</h1>
                  <p className={moduleCss.desc}>{dateFtt('yyyy.MM.dd', new Date(item.update_time))}</p>
                </div>
              </div>
            ))

            }

          </div>
        </div>
      </div >
    )
  }
}
export default List